import {CHANGE_MENU, REMOVE_MENU, REST_MENU, SET_MENU} from "./types";

const mutations = {
    [CHANGE_MENU]: (state, menuItem) => {
        let _menus = state.menus
        if(!_menus || !_menus.length) {
            _menus = JSON.parse(window.sessionStorage.getItem('menus'))
        }
        if(!menuItem) {
            return
        }
        state.menus = _menus.map(item => {
            return {
                ...item,
                isActive: menuItem.id === item.id
            }
        })
        // window.sessionStorage.removeItem('menus')
        // window.sessionStorage.setItem('menus', JSON.stringify(state.menus))
        // console.log(state.menus)
    },
    [SET_MENU]: (state, menus) => {
        state.menus = menus
        // window.sessionStorage.removeItem('menus')
        // window.sessionStorage.setItem('menus', JSON.stringify(menus))
        // console.log(state.menus)
    },
    [REMOVE_MENU]: (state) => {
        window.sessionStorage.removeItem('menus')
        state.menus = []
    },
    [REST_MENU]: (state, _) => {

        let _menus = state.menus
        if (!_menus) {
            const _jsonMenus = window.sessionStorage.getItem('menus')
            _menus = JSON.parse(_jsonMenus)
        }
        _menus.forEach((item, index) => {
            item.isActive = index === 0
        })
        // console.log('REST_MENU', _menus)
        state.menus = _menus
        window.sessionStorage.removeItem('menus')
        window.sessionStorage.setItem('menus', JSON.stringify(_menus))
        // console.log(state.menus)
    }
}
export default mutations